import { render, staticRenderFns } from "./Modals.vue?vue&type=template&id=56253c9a&scoped=true&"
import script from "./Modals.vue?vue&type=script&lang=js&"
export * from "./Modals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56253c9a",
  null
  
)

export default component.exports